import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { IComboBoxOption, IMaterial, IMaterialInformationFormSection, MaterialContext } from "../../interfaces";
import { Sort, Values } from "../../utils";
import { AddFromInventoryDialog } from "../AddFromInventoryDialog";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { MaterialInputDialog } from "../MaterialInputDialog";
import { MaterialTableRow } from "./MaterialTableRow";

export const MaterialInformationForm: React.FC<IMaterialInformationFormSection> = ({
    entityId,
    status,
    materials,
    onUpdateMaterials,
    onUpdateMaterial,
    onImportComplete,
    readonly,
    saving,
    ...props
}: IMaterialInformationFormSection) => {


    const [returnStatuses, setReturnStatuses] = useState<IComboBoxOption[]>([]);

    const getMaterials = (statusId?: number) => {
        //deep copy the object
        let clone = cloneDeep(materials);

        //order materials alphabetically
        Sort.materials(clone);

        if (statusId)
            return clone.filter(x => x.statusId === statusId)

        return clone;

    }

    const copyMaterial = (material: IMaterial) => {
        let copy = cloneDeep(material);
        copy.materialId = undefined;
        addMaterial(copy);
    }

    const addMaterial = (material: IMaterial) => {

        let model = getMaterials();

        model.push(material);

        onUpdateMaterials(model);
    }



    const removeMaterial = (material: IMaterial) => {

        let model: IMaterial[] = getMaterials().filter(x =>
            JSON.stringify(x) !== JSON.stringify(material)
        );

        onUpdateMaterials(model);
    }

    useEffect(() => {
        if (returnStatuses.length === 0)
            Values.setValues("expectedmaterialreturnstates", setReturnStatuses);
    }, [materials, returnStatuses.length])

    const MaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Expected Return Condition</TableCell>

                <TableCell />
            </TableRow>
        </TableHead>);
    }

    return (
        <Card>

            <FormSectionHeader label="Materials" saving={saving} />

            <CardContent>

                <Grid container spacing={4}>
                    {materials.length > 0 ? <>
                        {
                            getMaterials(1).length > 0 &&
                            <Grid item xs={12}>
                                <TableContainer>
                                    <Table>
                                        <MaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(1).map((material, i) =>

                                                <MaterialTableRow
                                                    material={material}
                                                    returnStatuses={returnStatuses}
                                                    onUpdate={onUpdateMaterial}
                                                    onCopy={() => copyMaterial(material)}
                                                    onRemove={() => removeMaterial(material)}
                                                    readonly={readonly}
                                                    key={i}
                                                />

                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        }
                        {
                            getMaterials(2).length > 0 &&
                            <Grid item xs={12}>

                                <Typography variant="h6" color="primary">Inventory Material</Typography>

                                <TableContainer>
                                    <Table>
                                        <MaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(2).map((material, i) =>

                                                <MaterialTableRow
                                                    material={material}
                                                    returnStatuses={returnStatuses}
                                                    onUpdate={onUpdateMaterial}
                                                    onRemove={() => removeMaterial(material)}
                                                    readonly={readonly}
                                                    key={i}
                                                />

                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        }
                        {
                            getMaterials(3).length > 0 &&
                            <Grid item xs={12}>

                                <Typography variant="h6" color="primary">Material Out</Typography>

                                <TableContainer>
                                    <Table>
                                        <MaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(3).map((material, i) =>
                                                <MaterialTableRow
                                                    material={material}
                                                    returnStatuses={returnStatuses}
                                                    onUpdate={onUpdateMaterial}
                                                    onRemove={() => removeMaterial(material)}
                                                    readonly={readonly}
                                                    key={i}
                                                />
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        }
                        {
                            getMaterials(4).length > 0 &&
                            <Grid item xs={12}>

                                <Typography variant="h6" color="primary">Material Out - Consumed</Typography>

                                <TableContainer>
                                    <Table>
                                        <MaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(4).map((material, i) =>
                                                <MaterialTableRow
                                                    material={material}
                                                    returnStatuses={returnStatuses}
                                                    onUpdate={onUpdateMaterial}
                                                    onRemove={() => removeMaterial(material)}
                                                    readonly={readonly}
                                                    key={i}
                                                />
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        }
                    </> :
                        <Grid item xs={12}>
                            <Typography
                                sx={{ pb: 2 }}
                                variant="subtitle2"
                            >
                                Populate the contract by clicking on 'Add Material' or dispatch materials from the basket to this contract.
                            </Typography>
                        </Grid>
                    }
                </Grid>


                {!readonly &&
                    <Grid container>
                        <MaterialInputDialog
                            entity={{ id: entityId ?? "", type: "CONTRACT" }}
                            context={MaterialContext.MaterialTable}
                            onSubmitMaterial={(material) => addMaterial(material)}
                            onImportComplete={onImportComplete}
                            focus={materials.length === 0}
                        />

                        <AddFromInventoryDialog
                            entityName="Contract"
                        />
                    </Grid>
                }
            </CardContent>
        </Card>
    );
}